import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import styled from '@emotion/styled';

export const SummaryPage = styled.div`
  padding-top: 96px;
  padding-bottom: 64px;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    padding-top: 96px;
    padding-bottom: 64px;
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding-top: 64px;
    padding-bottom: 64px;
  }
`;

export const SummaryFunctionLayout = styled.div`
  padding-top: 64px;

  display: flex;
  flex-direction: row;
  gap: 32px;

  justify-content: center;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    flex-direction: column;
    gap: 24px;
    padding-top: 32px;
  }
`;

export const SummaryTextLayout = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    order: 1;
  }
`;

export const SummaryImg = styled.div<{ img: string }>`
  width: 100%;
  aspect-ratio: 600/540;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);

  background-image: url(${(props) => props.img});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  flex: 1;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    order: 0;
  }
`;

export const SummaryToggleButton = styled.button<{ active: boolean }>`
  background: none;
  border: none;
  cursor: pointer;

  padding: 8px 16px 8px 0px;

  gap: 24px;
  display: flex;
  flex-direction: row;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    gap: 16px;
    padding: 8px 0px 8px 0px;
  }
`;
export const SumamryButtonTitle = styled.div`
  width: 100%;
  flex: 1;
  text-align: start;
`;

export const SummaryDescription = styled.div`
  padding: 8px 16px;
  color: #555;
`;

export const SummaryDivider = styled.div`
  height: 1px;
  width: 100%;
  background-color: #ddd;
`;

export const SummaryExtraRow = styled.div<{ gap: number }>`
  display: flex;
  width: 100%;
  align-items: center;
  gap: ${({ gap }) => (gap ? `${gap}px;` : '0px')};
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    gap: 16px;
  }
`;
